import React, { useContext } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { Button, Typography } from 'antd'
import { EditFilled, CloseOutlined } from '@ant-design/icons'

import { FlexRow, FlexColumn } from '../FlexboxReusables/FlexItems'
import ChangeProfilePicture from './ChangeProfilePicture'
import { AuthContext } from '../Auth/AuthContext'
import { UserRole } from './types'

type ProfileSummarySegmentProps = {
  id: number
  firstName: string
  lastName: string
  companyName: string
  position: string
  city: string
  state: string
  setEditProfilePicture: (editProfilePicture: boolean) => void
  editProfilePicture: boolean
}

const ProfileSummarySegment: React.FC<ProfileSummarySegmentProps> = (
  {
    id,
    firstName,
    lastName,
    companyName,
    position,
    city,
    state,
    setEditProfilePicture,
    editProfilePicture
  }: ProfileSummarySegmentProps) => {
  const { authUser, translateUserRole } = useContext(AuthContext)

  return (
    <>
      <FlexRow width='100%' justifyContent='space-evenly' alignItems='flex-start'>
        <FlexColumn width='20%'>
          <ChangeProfilePicture editMode={editProfilePicture} />
          <Button
            type='primary'
            onClick={() => setEditProfilePicture(!editProfilePicture)}
            style={{ marginTop: '1em'}}
          >
            {!editProfilePicture ? <EditIcon /> : <EndEditIcon />}
            <FormattedMessage id='generic.edit' />
          </Button>
        </FlexColumn>
        <FlexColumn width='20%'>
          <FlexRow justifyContent='flex-start'>
            <Typography.Text>
              {companyName}
            </Typography.Text>
          </FlexRow>
          <FlexRow justifyContent='flex-start'>
            <Typography.Title level={4}>
              {firstName} {lastName}
            </Typography.Title>
          </FlexRow>
          <FlexRow justifyContent='flex-start'>
            <Typography.Title level={5}>
              {position}
            </Typography.Title>
          </FlexRow>
          {city && (
            <FlexRow justifyContent='flex-start'>
              <Typography.Text>
                {city}, {state}
              </Typography.Text>
            </FlexRow>
          )}
        </FlexColumn>

        <FlexColumn alignItems='flex-start' width='20%'>
          <FlexRow justifyContent='flex-start'>
            <Typography.Title level={4}>
              <FormattedMessage id='generic.role' />:{' '}
              {translateUserRole(authUser.role.toLowerCase() as UserRole)}
            </Typography.Title>
          </FlexRow>
          <FlexRow justifyContent='flex-start'>
          User Id: {id}
          </FlexRow>
        </FlexColumn>
      </FlexRow>
    </>
  )
}

export default ProfileSummarySegment

const EditIcon = styled(EditFilled)`
  margin-right: 1em;
`

const EndEditIcon = styled(CloseOutlined)`
  margin-right: 1em;
`